import React, { useEffect, useRef, useState } from 'react';
import { ESTILOS_MOBILE } from './estilosMobile';
import { InicioMobile } from './InicioMobile';
import { MasMobile } from './MasMobile';
import { ProximaEtapaMobile } from './ProximaEtapaMobile';
import { EmpleadosMobile } from './empleados/EmpleadosMobile';
import emblemaSigrh from './assets/sigrh-emblema-192.png';

// Shell Mobile (M.1): header compacto + contenido + navegación inferior.
// Recibe de App.jsx el mismo `usuario`/`onLogout` que Desktop y la lista de
// `empleados` que App ya mantiene; el shell no llama APIs.

// Módulos con vista Mobile planeada que aún no es funcional: llevan a un
// placeholder dentro del shell, nunca a la vista Desktop.
export const MODULOS_MOBILE = {
  evaluaciones: {
    titulo: 'Evaluaciones',
    icono: 'ti-clipboard-check',
    estado: 'Próxima etapa',
    mensaje: 'Las evaluaciones de desempeño desde el teléfono se habilitarán en la siguiente etapa. Mientras tanto, usa SIGRH desde una computadora.'
  },
  comedor: {
    titulo: 'Comedor',
    icono: 'ti-bowl',
    estado: 'Próxima etapa',
    mensaje: 'La gestión de comedor desde el teléfono se habilitará en la siguiente etapa. Mientras tanto, usa SIGRH desde una computadora.'
  },
  // Fuera de la navegación por ahora (M.1.1). Regresa con su etapa funcional
  // (capacitación → evidencia → cámara → preview → subir).
  capacitaciones: {
    titulo: 'Capacitaciones',
    icono: 'ti-school',
    estado: 'Próxima etapa',
    mensaje: 'El registro de capacitaciones desde el teléfono se habilitará en la siguiente etapa. Mientras tanto, usa SIGRH desde una computadora.'
  }
};

const TABS = [
  { id: 'inicio', label: 'Inicio', icono: 'ti-home' },
  { id: 'empleados', label: 'Empleados', icono: 'ti-users' },
  { id: 'evaluaciones', label: 'Evaluaciones', icono: 'ti-clipboard-check' },
  { id: 'comedor', label: 'Comedor', icono: 'ti-bowl' },
  { id: 'mas', label: 'Más', icono: 'ti-menu-2' }
];

// Estado de Empleados que debe sobrevivir a la navegación interna y al cambiar
// de pestaña. Se guarda el ID seleccionado, nunca el objeto: el refresh
// periódico de App reemplaza la lista sin dejar un empleado viejo en pantalla.
export const ESTADO_EMPLEADOS_INICIAL = {
  busqueda: '', seleccionadoId: null, seccionExpediente: null, scrollY: 0, scrollYExpediente: 0
};

// Cada nivel interno abierto (expediente, sección del expediente) agrega UNA
// entrada de historial marcada con la clave CLAVE_HISTORIAL.
const CLAVE_HISTORIAL = 'sigrhMobile';
const nivelEnHistorial = (state) => (state && state[CLAVE_HISTORIAL]) || null;

export function MobileShell({ usuario, onLogout, empleados = [], cambios = [], cargandoEmpleados = false }) {
  const [seccion, setSeccion] = useState('inicio');
  const [estadoEmpleados, setEstadoEmpleados] = useState(ESTADO_EMPLEADOS_INICIAL);
  const empleadoAbierto = estadoEmpleados.seleccionadoId != null;
  // Guardia de salida (M.2B.2): una vista con trabajo sin guardar (documento
  // pendiente de subir) publica aquí { confirmar(continuar) }. Mientras exista,
  // salir de la sección pide confirmación en la UI en vez de perderlo.
  const guardiaSalida = useRef(null);
  const estadoActual = useRef(estadoEmpleados);
  estadoActual.current = estadoEmpleados;

  useEffect(() => {
    try { window.scrollTo(0, 0); } catch { /* entornos sin scroll */ }
  }, [seccion]);

  // Atrás de Android / PWA: popstate refleja la entrada de historial a la que
  // se llegó (lista -> expediente -> sección). La flecha ← hace history.back(),
  // así ambas rutas producen lo mismo. Nunca se hace pushState desde
  // popstate: sin loops.
  useEffect(() => {
    const alNavegar = (evento) => {
      const nivel = nivelEnHistorial(evento.state);
      // Atrás con documento pendiente: se restaura UNA vez la entrada de la
      // sección (pushState no dispara popstate: sin loops) y se pide
      // confirmación; si se descarta, la guardia se retira y se retrocede.
      const guardia = guardiaSalida.current;
      const actual = estadoActual.current;
      if (guardia && actual.seleccionadoId != null && actual.seccionExpediente != null) {
        const sigue = nivel && nivel.nivel === 'seccion' && nivel.id === actual.seleccionadoId && nivel.seccion === actual.seccionExpediente;
        if (!sigue) {
          window.history.pushState({ [CLAVE_HISTORIAL]: { nivel: 'seccion', id: actual.seleccionadoId, seccion: actual.seccionExpediente } }, '');
          guardia.confirmar(() => window.history.back());
          return;
        }
      }
      setEstadoEmpleados(prev => {
        if (!nivel) {
          return prev.seleccionadoId == null && prev.seccionExpediente == null
            ? prev : { ...prev, seleccionadoId: null, seccionExpediente: null };
        }
        const seccionExpediente = nivel.nivel === 'seccion' ? nivel.seccion : null;
        return prev.seleccionadoId === nivel.id && prev.seccionExpediente === seccionExpediente
          ? prev : { ...prev, seleccionadoId: nivel.id, seccionExpediente };
      });
    };
    window.addEventListener('popstate', alNavegar);
    return () => window.removeEventListener('popstate', alNavegar);
  }, []);

  const abrirEmpleado = (id) => {
    if (empleadoAbierto) return;
    const idTexto = String(id);
    setEstadoEmpleados(prev => ({ ...prev, seleccionadoId: idTexto, seccionExpediente: null, scrollY: window.scrollY || 0 }));
    window.history.pushState({ [CLAVE_HISTORIAL]: { nivel: 'expediente', id: idTexto } }, '');
  };

  const abrirSeccionExpediente = (seccionExpediente) => {
    const { seleccionadoId } = estadoEmpleados;
    if (seleccionadoId == null || estadoEmpleados.seccionExpediente != null) return;
    setEstadoEmpleados(prev => ({ ...prev, seccionExpediente, scrollYExpediente: window.scrollY || 0 }));
    window.history.pushState({ [CLAVE_HISTORIAL]: { nivel: 'seccion', id: seleccionadoId, seccion: seccionExpediente } }, '');
  };

  // Cierra UN nivel consumiendo la entrada propia; si no existe (p. ej. tras
  // recargar) sólo cierra, para no sacar al usuario de la app.
  const cerrarNivel = () => {
    if (guardiaSalida.current) { guardiaSalida.current.confirmar(cerrarNivel); return; }
    if (nivelEnHistorial(window.history.state)) {
      window.history.back();
    } else {
      setEstadoEmpleados(prev => (prev.seccionExpediente != null
        ? { ...prev, seccionExpediente: null }
        : { ...prev, seleccionadoId: null }));
    }
  };

  // La navegación inferior siempre lleva a la raíz de la sección elegida y
  // consume las entradas internas abiertas (1 o 2).
  const irASeccion = (destino) => {
    if (guardiaSalida.current) { guardiaSalida.current.confirmar(() => irASeccion(destino)); return; }
    if (empleadoAbierto) {
      const nivel = nivelEnHistorial(window.history.state);
      if (nivel) window.history.go(nivel.nivel === 'seccion' ? -2 : -1);
      setEstadoEmpleados(prev => ({ ...prev, seleccionadoId: null, seccionExpediente: null }));
    }
    setSeccion(destino);
  };

  const inicial = (usuario.name || usuario.email || '?').trim().charAt(0);

  let vista;
  if (seccion === 'inicio') {
    vista = <InicioMobile usuario={usuario} emblema={emblemaSigrh} />;
  } else if (seccion === 'mas') {
    vista = <MasMobile usuario={usuario} inicial={inicial} onLogout={onLogout} />;
  } else if (seccion === 'empleados') {
    vista = (
      <EmpleadosMobile
        empleados={empleados}
        cambios={cambios}
        loading={cargandoEmpleados}
        estado={estadoEmpleados}
        setEstado={setEstadoEmpleados}
        onAbrir={abrirEmpleado}
        onAbrirSeccion={abrirSeccionExpediente}
        onCerrar={cerrarNivel}
        guardiaSalida={guardiaSalida}
      />
    );
  } else {
    vista = (
      <ProximaEtapaMobile
        modulo={MODULOS_MOBILE[seccion]}
        textoVolver="Ir al inicio"
        onVolver={() => setSeccion('inicio')}
      />
    );
  }

  return (
    <div className="m-root">
      <style>{ESTILOS_MOBILE}</style>

      <header className="m-header">
        <div className="m-header-row">
          <div className="m-header-logo"><img src={emblemaSigrh} alt="" width="32" height="32" /></div>
          <div className="m-header-marca">
            <div className="m-header-nombre">SIGRH</div>
            <div className="m-header-empresa">Aceros y Laminados Leal</div>
          </div>
          <button
            type="button"
            className="m-avatar-btn"
            aria-label={`Cuenta y opciones de ${usuario.name || usuario.email}`}
            onClick={() => irASeccion('mas')}
          >
            <span className="m-avatar" aria-hidden="true">{inicial}</span>
          </button>
        </div>
      </header>

      <main className="m-main" key={seccion}>
        {vista}
      </main>

      <nav className="m-nav" aria-label="Navegación principal">
        <ul>
          {TABS.map(t => (
            <li key={t.id}>
              <button
                type="button"
                className="m-nav-btn"
                aria-current={seccion === t.id ? 'page' : undefined}
                onClick={() => irASeccion(t.id)}
              >
                <span className="m-nav-icono"><i className={`ti ${t.icono}`} aria-hidden="true"></i></span>
                <span className="m-nav-label" data-label={t.label}>{t.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
